import React from "react";
import Modal from "react-modal";

const detailStyles = {
  content: {
    top: "50%", left: "50%", right: "auto", bottom: "auto",
    transform: "translate(-50%, -50%)",
    padding: "24px", borderRadius: "12px",
    width: "min(720px, 92vw)", maxHeight: "85vh",
    overflow: "auto", fontFamily: "Roboto, sans-serif",
  },
  overlay: { backgroundColor: "rgba(0,0,0,0.5)", zIndex: 102 },
};

// Estilos inline para el contenido del modal
const ui = {
  container: { position: "relative" }, // para posicionar la X
  closeBtn: {
    position: "absolute",
    top: 10,
    right: 10,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 34,
    height: 34,
    border: "none",
    borderRadius: 9999,
    background: "transparent",
    color: "#6c757d",
    cursor: "pointer",
  },
  closeIcon: { fontSize: 18 },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
    paddingRight: 40, // espacio para que la X no se empalme
  },
  titleSmall: { fontWeight: 400, color: "#666" },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  addressWrap: { gridColumn: "1 / -1", marginTop: 8 },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 18,
  },
  btnBase: {
    border: "none",
    borderRadius: 10,
    padding: "10px 16px",
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 1px 2px rgba(0,0,0,.06)",
  },
  btnRed: { background: "#dc3545", color: "#fff" },
  btnBlue: { background: "#0d6efd", color: "#fff" },
};

export default function ContactDetailModal({ isOpen, onClose, data, onEdit }) {
  if (!data) return null;

  const direccion = [
    data.domicilio,
    data.numeroExt,
    data.numeroInt ? `Int ${data.numeroInt}` : null,
    data.colonia,
    data.codigoPostal,
    data.ciudad,
    data.estado,
  ].filter(Boolean).join(", ");

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={detailStyles}
      contentLabel="Detalle de contacto"
    >
      <div style={ui.container}>
        {/* X arriba-derecha */}
        <button type="button" onClick={onClose} aria-label="Cerrar" style={ui.closeBtn}>
          <i className="bi bi-x-lg" style={ui.closeIcon} />
        </button>

        {/* Encabezado */}
        <div style={ui.header}>
          <h3 style={{ margin: 0 }}>
            {data.empresa || "—"}{" "}
            <small style={ui.titleSmall}>({data.tipo || "—"})</small>
          </h3>
        </div>

        {/* Contenido */}
        <div style={ui.grid}>
          <Field label="ID" value={data.id} />
          <Field label="Moneda" value={data.moneda} />
          <Field label="RFC" value={data.rfc} />
          <Field label="Régimen fiscal" value={data.regimenFiscal} />
          <Field label="Teléfono" value={data.telefono} />
          <Field label="Correo" value={data.correo} />
          <Field label="Cond. de pago" value={data.condicionesPago} />
          <Field label="Fecha de alta" value={data.fechaAlta} />

          <div style={ui.addressWrap}>
            <small className="label">Dirección</small>
            <div>{direccion || "—"}</div>
          </div>
        </div>

        {/* Botones */}
        <div style={ui.actions}>
          <button type="button" onClick={onClose} style={{ ...ui.btnBase, ...ui.btnRed }}>
            Cerrar
          </button>
          {onEdit && (
            <button type="button" onClick={onEdit} style={{ ...ui.btnBase, ...ui.btnBlue }}>
              Editar
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
}

function Field({ label, value }) {
  return (
    <div>
      <small className="label">{label}</small>
      <div>{value || "—"}</div>
    </div>
  );
}